import React from 'react';
import {
  Box,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  Stack,
  IconButton
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const HeroSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        position: 'relative',
        height: { xs: '90vh', md: '95vh' },
        backgroundColor: 'rgba(0, 60, 30, 0.15)', // faint elegant green tint
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        width: '100%',
        textAlign: 'center',
      }}
    >
      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9 }}
        sx={{
          zIndex: 2,
          maxWidth: 850,
          color: '#ffffff',
        }}
      >
        {/* Headline */}
        <Typography
          variant={isMobile ? 'h4' : 'h3'}
          fontWeight={800}
          gutterBottom
          sx={{
            color: '#ffffff',
            textShadow: '0px 2px 8px rgba(0,0,0,0.4)',
            letterSpacing: 1,
          }}
        >
          SEE IT. REPORT IT. SOLVE IT.
        </Typography>

        {/* Shortened Subtext */}
        <Typography
          variant="h6"
          sx={{
            mb: 5,
            color: 'rgba(255,255,255,0.9)',
            maxWidth: 600,
            mx: 'auto',
            lineHeight: 1.5,
          }}
        >
          Join the movement 🌍. Report issues and help protect our planet.
        </Typography>

        {/* Call-to-Actions */}
        <Stack
          direction="row"
          justifyContent="center"
          spacing={2}
          flexWrap="wrap"
          gap={2}
        >
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/report')}
            sx={{
              background: 'linear-gradient(135deg,rgb(230, 192, 0), #00c853)',
              fontWeight: 600,
              px: 4,
              borderRadius: '14px',
              textTransform: 'none',
              color: 'rgb(8, 73, 68)',
              boxShadow: '0px 4px 12px rgba(0,0,0,0.3)',
              '&:hover': {
                background: 'linear-gradient(135deg, #00c853, #009624)',
              },
            }}
          >
            Report an Issue
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate('/issues')}
            sx={{
              color: '#00e676',
              borderColor: '#00e676',
              fontWeight: 600,
              px: 4,
              borderRadius: '14px',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: 'rgba(0,230,118,0.1)',
                borderColor: '#00c853',
              },
            }}
          >
            View Reports
          </Button>
        </Stack>

        {/* Scroll Arrow */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 1.2,
            duration: 0.8,
            repeat: Infinity,
            repeatType: 'reverse',
          }}
        >
          <IconButton
            onClick={() =>
              document
                .getElementById('how-it-works')
                ?.scrollIntoView({ behavior: 'smooth' })
            }
            sx={{ mt: 8 }}
          >
            <KeyboardArrowDownIcon sx={{ fontSize: 48, color: '#00e676' }} />
          </IconButton>
        </motion.div>
      </Box>
    </Box>
  );
};

export default HeroSection;
